export const ADD_TEMPLATE: string = "ADD_TEMPLATE";
export const CLEAR_TEMPLATES: string = "CLEAR_TEMPLATES";

export function addTemplate(template_Id: string, companyId: string, channelId:number, name:string, body: string, status:number,createdBy: string, createdAt:string): IAddTemplateActionType {
    return { type: ADD_TEMPLATE, template_Id:template_Id, companyId: companyId, channelId:channelId, name:name, body:body, status:status, createdBy:createdBy, createdAt:createdAt};
}
export function clearTemplates(): IClearTemplateActionType {
    return { type: CLEAR_TEMPLATES};
}

interface IAddTemplateActionType { 
    type:string,
    template_Id: string, 
    companyId: string, 
    channelId:number, 
    name:string, 
    body: string, 
    status:number,
    createdBy: string, 
    createdAt:string 
}

interface IClearTemplateActionType { type:string }